import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';
import { CollectionDeleteResponse, CollectionResponse, CollectionsListResponse } from '../state/collections.models';

@Injectable({
  providedIn: 'root',
})
export class CollectionsService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  private get baseUrl(): string {
    return `${this.apiData.apiURL}api/${this.client}/collection`;
  }

  getCollections(): Observable<CollectionsListResponse> {
    return this.http.get<CollectionsListResponse>(this.baseUrl);
  }

  createCollection(name: string): Observable<CollectionResponse> {
    return this.http.post<CollectionResponse>(this.baseUrl, { name });
  }

  renameCollection(id: number, name: string): Observable<CollectionResponse> {
    return this.http.patch<CollectionResponse>(`${this.baseUrl}/${id}`, { name });
  }

  deleteCollection(id: number): Observable<CollectionDeleteResponse> {
    return this.http.delete<CollectionDeleteResponse>(`${this.baseUrl}/${id}`);
  }

  addDocuments(id: number, documentIds: number[]): Observable<CollectionResponse> {
    return this.http.post<CollectionResponse>(`${this.baseUrl}/${id}/documents`, { document_ids: documentIds });
  }

  removeDocuments(id: number, documentIds: number[]): Observable<CollectionResponse> {
    return this.http.delete<CollectionResponse>(`${this.baseUrl}/${id}/documents`, {
      body: { document_ids: documentIds },
    });
  }
}
